/* UKLISS theme — global interactions */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* =========================================================
     Header — mega menu (hover with intent, click, keyboard)
     Spec: menu stays open while the pointer is inside the
     panel; closes on outside click or Escape.
     ========================================================= */
  (function megaMenu() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var triggers = Array.prototype.slice.call(header.querySelectorAll('[data-mega-trigger]'));
    if (!triggers.length) return;

    var openId = null;
    var closeTimer = null;

    function panelOf(id) { return document.getElementById(id); }

    function open(id) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openId === id) return;
      if (openId) shut(openId);
      var p = panelOf(id);
      if (!p) return;
      p.hidden = false;
      // next frame so the transition runs
      requestAnimationFrame(function () { p.classList.add('is-open'); });
      triggers.forEach(function (t) {
        if (t.dataset.megaTrigger === id) t.setAttribute('aria-expanded', 'true');
      });
      openId = id;
    }

    function shut(id) {
      var p = panelOf(id);
      if (!p) return;
      p.classList.remove('is-open');
      triggers.forEach(function (t) {
        if (t.dataset.megaTrigger === id) t.setAttribute('aria-expanded', 'false');
      });
      var hide = function () { if (!p.classList.contains('is-open')) p.hidden = true; };
      if (reduceMotion) hide(); else setTimeout(hide, 220);
      if (openId === id) openId = null;
    }

    var suppressFocusOpen = false;
    function closeAll() { if (openId) shut(openId); }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 140);
    }
    function cancelClose() { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } }

    triggers.forEach(function (t) {
      var id = t.dataset.megaTrigger;
      t.addEventListener('mouseenter', function () { open(id); });
      t.addEventListener('focus', function () { if (!suppressFocusOpen) open(id); });
      t.addEventListener('mouseleave', scheduleClose);
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (openId === id) shut(id); else open(id);
      });
      var p = panelOf(id);
      if (p) {
        p.addEventListener('mouseenter', cancelClose);
        p.addEventListener('mouseleave', scheduleClose);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openId) {
        var t = header.querySelector('[data-mega-trigger="' + openId + '"]');
        closeAll();
        suppressFocusOpen = true;
        if (t) t.focus();
        setTimeout(function () { suppressFocusOpen = false; }, 100);
      }
    });
    document.addEventListener('click', function (e) {
      if (openId && !header.contains(e.target)) closeAll();
    });
    // focus moving out of the header closes the panel
    header.addEventListener('focusout', function (e) {
      if (openId && !header.contains(e.relatedTarget)) closeAll();
    });
  })();

  /* ---------- Mobile drawer + accordions ---------- */
  (function drawer() {
    var el = document.getElementById('MobileDrawer');
    function set(open) {
      if (!el) return;
      el.classList.toggle('is-open', open);
      el.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open]')) set(true);
      if (e.target.closest('[data-drawer-close]')) set(false);
      var t = e.target.closest('[data-macc-toggle]');
      if (t) {
        var item = t.closest('[data-macc]');
        var isOpen = item.classList.toggle('is-open');
        t.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  })();

  /* =========================================================
     Hero carousel — Apple-style dot capsule pinned to the
     banner bottom. Swipe, keyboard, autoplay (pauses on
     hover / focus / tab-hidden / reduced motion).
     ========================================================= */
  document.querySelectorAll('[data-hero-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    if (!track || slides.length < 1) return;

    var index = 0;
    var timer = null;
    var delay = parseInt(root.dataset.autoplay || '0', 10);
    var paused = false;

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d, i) {
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
        d.tabIndex = i === index ? 0 : -1;
      });
      slides.forEach(function (s, i) {
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        // keep offscreen slides out of the tab order
        s.querySelectorAll('a, button').forEach(function (f) { f.tabIndex = i === index ? 0 : -1; });
      });
    }
    function go(i) {
      index = (i + slides.length) % slides.length;
      render();
    }
    function start() {
      if (!delay || slides.length < 2 || reduceMotion) return;
      stop();
      timer = setInterval(function () { if (!paused) go(index + 1); }, delay);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); start(); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); dots[index].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); dots[index].focus(); }
      });
    });
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () { paused = document.hidden; });

    // touch / pointer swipe
    var sx = 0, sy = 0, tracking = false;
    root.addEventListener('touchstart', function (e) {
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { go(index + (dx < 0 ? 1 : -1)); start(); }
    }, { passive: true });

    render();
    start();
  });

  /* =========================================================
     Horizontal carousels (product shelf + hair talk)
     drag to scroll, snap, progress bar, prev/next
     ========================================================= */
  /*
    Press-and-drag rail (wavytalk pattern): a short press on a card is a normal
    click that follows the link, a press that travels more than THRESHOLD px
    turns into a drag — even when it started on a card, an image or the Add
    button. Deliberately does NOT use setPointerCapture: capturing retargets the
    follow-up click to the viewport, which is why card clicks did nothing.
  */
  function bindDragScroll(vp) {
    const threshold = 6;
    let down = false;
    let pointerId = null;
    let startX = 0;
    let startLeft = 0;
    let dragging = false;
    let suppressClick = false;

    vp.addEventListener('dragstart', function (event) { event.preventDefault(); });

    vp.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      suppressClick = false;
      dragging = false;
      vp.classList.remove('is-dragging');
      if (event.pointerType !== 'mouse') return;
      down = true;
      pointerId = event.pointerId;
      startX = event.clientX;
      startLeft = vp.scrollLeft;
    });

    document.addEventListener('pointermove', function (event) {
      if (!down || event.pointerId !== pointerId) return;
      const delta = event.clientX - startX;
      if (!dragging && Math.abs(delta) > threshold) {
        dragging = true;
        vp.classList.add('is-dragging');
      }
      if (!dragging) return;
      event.preventDefault();
      vp.scrollLeft = startLeft - delta;
    });

    function end(event) {
      if (!down || (event.pointerId != null && event.pointerId !== pointerId)) return;
      suppressClick = dragging && event.type === 'pointerup';
      down = false;
      pointerId = null;
      dragging = false;
      setTimeout(function () {
        vp.classList.remove('is-dragging');
        suppressClick = false;
      }, 0);
    }
    document.addEventListener('pointerup', end);
    document.addEventListener('pointercancel', end);
    window.addEventListener('blur', end);

    vp.addEventListener('click', function (event) {
      if (!suppressClick || event.detail === 0) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  document.querySelectorAll('[data-shelf]').forEach(function (root) {
    var bar = root.querySelector('[data-shelf-bar]');

    function activeViewport() {
      // the panels carry [hidden], not the viewports — look at the panel first
      return root.querySelector('[data-shelf-panel]:not([hidden]) [data-shelf-viewport]')
          || root.querySelector('[data-shelf-viewport]:not([hidden])')
          || root.querySelector('[data-shelf-viewport]');
    }

    var progress = root.querySelector('[data-shelf-progress]');
    var hint = root.querySelector('[data-shelf-hint]');

    function updateBar() {
      var vp = activeViewport();
      if (!bar || !vp) return;
      var max = vp.scrollWidth - vp.clientWidth;
      // nothing to scroll -> the bar and hint would be misleading
      var scrollable = max > 4;
      if (progress) progress.hidden = !scrollable;
      if (hint) hint.hidden = !scrollable;
      if (!scrollable) return;
      // Incremental fill: how much of the rail has been revealed so far.
      // Starts at the share already on screen and grows to 100% at the end.
      var seen = (vp.scrollLeft + vp.clientWidth) / Math.max(vp.scrollWidth, 1);
      seen = Math.min(Math.max(seen, 0.06), 1);
      bar.style.width = (seen * 100) + '%';
      bar.style.transform = 'none';
    }

    root.querySelectorAll('[data-shelf-viewport]').forEach(function (vp) {
      bindDragScroll(vp);
      vp.addEventListener('scroll', updateBar, { passive: true });
    });

    // tabs
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-shelf-tab]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        root.querySelectorAll('[data-shelf-panel]').forEach(function (p) {
          p.hidden = p.dataset.shelfPanel !== tab.dataset.shelfTab;
        });
        var vp = activeViewport();
        if (vp) vp.scrollLeft = 0;
        updateBar();
      });
    });

    window.addEventListener('resize', updateBar);
    updateBar();
    // images can change scrollWidth once loaded
    window.addEventListener('load', updateBar);
  });

  document.querySelectorAll('[data-talk]').forEach(function (root) {
    var vp = root.querySelector('[data-talk-viewport]');
    var prev = root.querySelector('[data-talk-prev]');
    var next = root.querySelector('[data-talk-next]');
    if (!vp) return;
    bindDragScroll(vp);

    function step() {
      var card = vp.querySelector('.talk3__card');
      return card ? card.getBoundingClientRect().width + 24 : vp.clientWidth * 0.8;
    }
    function sync() {
      var max = vp.scrollWidth - vp.clientWidth - 1;
      if (prev) prev.disabled = vp.scrollLeft <= 0;
      if (next) next.disabled = vp.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    vp.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- Generic pill tabs (legacy sections) ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var buttons = group.querySelectorAll('[data-tab-target]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        var scope = document.getElementById(group.dataset.tabs) || document;
        scope.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          panel.hidden = panel.dataset.tabPanel !== btn.dataset.tabTarget;
        });
      });
    });
  });

  /* =========================================================
     PDP anchor subnav: floating capsule + scroll-spy
     ========================================================= */
  (function pdpSubnav() {
    var subnav = document.querySelector('[data-anchor-nav]');
    if (!subnav) return;
    var bar = subnav.querySelector('.pdp-subnav__bar') || subnav;
    var header = document.querySelector('.section-site-header');
    subnav.classList.add('pdp-subnav--js');

    var links = Array.prototype.slice.call(subnav.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (l) {
      var el = document.querySelector(l.getAttribute('href'));
      return el ? { link: l, el: el } : null;
    }).filter(Boolean);

    var spyLockUntil = 0, floating = false, undockTimer = null, lastActive = null;

    function headerBottom() {
      if (!header) return 0;
      return Math.max(0, header.getBoundingClientRect().bottom);
    }
    function updateFloat() {
      var floatTop = headerBottom() + 10;
      var shouldFloat = subnav.getBoundingClientRect().top <= floatTop + (floating ? 4 : 0);
      if (shouldFloat === floating) return;
      floating = shouldFloat;
      if (floating) {
        if (undockTimer) { clearTimeout(undockTimer); undockTimer = null; }
        bar.classList.remove('is-undocking');
        subnav.style.minHeight = bar.offsetHeight + 'px';
        bar.style.setProperty('--subnav-float-top', Math.round(floatTop) + 'px');
        bar.classList.add('is-floating');
      } else {
        bar.classList.remove('is-floating');
        subnav.style.minHeight = '';
        bar.classList.add('is-undocking');
        if (undockTimer) clearTimeout(undockTimer);
        undockTimer = setTimeout(function () { bar.classList.remove('is-undocking'); undockTimer = null; }, 200);
      }
    }
    function navOffset() { return headerBottom() + bar.offsetHeight + 26; }
    function setActive(link) {
      if (link === lastActive) return;
      lastActive = link;
      links.forEach(function (l) {
        l.classList.toggle('is-active', l === link);
        if (l === link) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
      });
      if (link) {
        var lr = link.getBoundingClientRect(), br = bar.getBoundingClientRect();
        if (lr.left < br.left || lr.right > br.right) {
          bar.scrollLeft += lr.left - br.left - (br.width - lr.width) / 2;
        }
      }
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var el = document.querySelector(link.getAttribute('href'));
        if (!el) return;
        e.preventDefault();
        setActive(link);
        spyLockUntil = Date.now() + 900;
        updateFloat();
        var top = el.getBoundingClientRect().top + window.scrollY - navOffset();
        window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
      });
    });
    function spy() {
      updateFloat();
      if (Date.now() < spyLockUntil || targets.length === 0) return;
      var current = null;
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        current = targets[targets.length - 1];
      } else {
        var threshold = navOffset() + 30;
        targets.forEach(function (t) { if (t.el.getBoundingClientRect().top <= threshold) current = t; });
      }
      setActive(current ? current.link : targets[0].link);
    }
    window.addEventListener('scroll', spy, { passive: true });
    window.addEventListener('resize', spy);
    spy();
  })();

  /* ---------- Sticky mobile PDP CTA ---------- */
  (function stickyAtc() {
    var stickyBar = document.querySelector('[data-sticky-atc]');
    var buyBox = document.querySelector('[data-buy-box]');
    if (!stickyBar || !buyBox || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(buyBox);
  })();

  /* ---------- Variant pills -> hidden select ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var select = picker.querySelector('select[name="id"]');
    picker.querySelectorAll('[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        picker.querySelectorAll('[data-variant-id]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (select) select.value = btn.dataset.variantId;
        var priceEl = document.querySelector('[data-product-price]');
        if (priceEl && btn.dataset.variantPrice) priceEl.textContent = btn.dataset.variantPrice;
      });
    });
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var revealIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); revealIo.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { revealIo.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-revealed'); });
  }
})();
